import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left bg-white p-4 rounded-lg mt-4" }
const _hoisted_2 = { class: "text-md font-bold text-gray-800" }
const _hoisted_3 = { class: "mt-1 text-sm text-gray-600" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionSimpleCard',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1)
  ]))
}
}

})